import { VectorLike, VectorLikes } from '@use-gpu/core';

export type Lerpable = number | VectorLike | VectorLikes;
export type LerpableRecord = Record<string, Lerpable>;

export type Tracks<T extends LerpableRecord> = {
  [K in keyof T]: Keyframe<T[K]>[];
};

export type TrackTypes<T extends LerpableRecord> = {
  [K in keyof T]?: EaseType;
};

export type KeyframeTypeOf<T> = T extends Keyframe<infer E> ? E : never;

export type Ease = 'cosine' | 'linear' | 'hold' | 'bezier';

export type EaseType = 'mat4' | 'quat' | 'angle' | 'number';

export type MakeSpline<T> = (a: T, b: T, knots?: T[]) => Spline<T>;
export type AutoSpline<T> = (a: T, b: T, c: T, d: T) => T[];
export type Spline<T> = (target: T, t: number) => T;
export type Lerp<T> = (target: T, a: T, b: T, t: number) => T;
export type Measure<T> = (a: T, b: T) => number;

export type EaseTypeImpl<T> = {
  spline: MakeSpline<T>,
  auto: AutoSpline<T>,
  lerp: Lerp<T>,
  measure: Measure<T>,
};

export type Keyframe<T extends Lerpable> = {
  time: number,
  value: T,
  ease?: Ease,
  bezier?: number[],
  knots?: T[],
};

export type AutoKeyframe<T extends Lerpable> = {
  time: number,
  value: T,

  speed?: number,
  in?: number,
  out?: number,

  knots?: T[],
};
